import { Component, OnInit, ViewEncapsulation, ViewChild, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { SelectItem, DataTable } from "primeng/primeng";
import { PaginationComponent } from '../../pagination/pagination.component';
import { PaginationService } from '../../../core/pagination/paginator.service';
import { PaymentService } from '../../../core/payments/payments.service';
import { IPagin } from '../../../core/pagination/IPaginator-model';
import * as _ from 'lodash';
import { ModalDirective } from "ngx-bootstrap";
import Popper from 'popper.js';
import Tooltip from 'tooltip.js';
import { AuthService } from "../../../core/auth/auth.service";
import { OpenPayService } from "../../../core/openpay/openpay.service";
import { ElectronicPaymentModel, TransfersModel } from '../../../core/payments/electronic-payment.model';
import { MessageService } from "primeng/components/common/messageservice";

declare var $;

@Component({
  selector: 'read-dt',
  templateUrl: 'read-dt.component.html',
  styleUrls: ['read-dt.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReadDtComponent implements OnInit, AfterViewInit {


  /*pagin: any = { page: 0, size: 4, path: 'people/get-all' }*/
  //itemsSelected: PaymentModel[] = [];
  itemsSelected: TransfersModel[] = [];
  actualPage: number = 0;
  comisionesAmount: number = 0;
  totalAmount: number = 0;

  @ViewChild("dt")
  dt: DataTable

  @Input("content")
  content;

  @Input("loading")
  loading;

  @Input("showDescription")
  showDescription;

  @Input("totalSize")
  totalSize;

  @Output() getPage: EventEmitter<any> = new EventEmitter();

  private exportToolTip;


  constructor(private paginationService: PaginationService,
    private authService: AuthService,
    private openpay: OpenPayService,
    private messageService: MessageService,
    private paymentService: PaymentService) {
  }

  ngAfterViewInit() {
    //$('#export').tooltip();
    this.exportToolTip = new Tooltip($('#export'), {
      placement: 'button',
      title: 'Solo se descargaran los registros de la pagina actual',
      trigger: 'hover'
    });
  }

  ngOnInit() {
    /*this.data = { page: 0, size: 20, path: 'payments' };
    console.log('Token en e-account', this.openpay.deviceSessionId);
    this.getUserInfoFromService();
    super.ngOnInit();*/
  }

  /*private getUserInfoFromService(){
    this.authService.getCustomerByUsername()
      .subscribe(response => {
        console.log('Mostramos la informacion del usuario',response);
      },
      err => {
        this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err
          });
      });
  }*/

  paginate(event) {
    this.getPage.emit(event);
    /*this.data.size = event.rows;
    this.actualPage = event.page;
    this.getPage(this.actualPage);
*/
    //event.first = Index of the first record
    //event.rows = Number of rows to display in new page
    //event.page = Index of the new page
    //event.pageCount = Total number of pages
  }

  getUser() {

    console.log('El usuario es:', this.authService.user);
  }

  /*handleChange(event){
    console.log('Mostramos el index',event.index);
    if(event.index == 0){
      this.getPage(this.actualPage);
    } else if(event.index == 1){
      this.data2Find = { page: 0, size: 20, path: 'award/transactions/status' };
      this.getPagePaymentsByStatusage(this.actualPage, 'requested');
    }
  }

  doElectronicPayout() {
    this.loading = true;



    this.paymentService.doElectronicPayout(this.fillModel()).finally(() => {
        this.itemsSelected = [];
        this.getPage(this.actualPage);
      })
      .subscribe(response => {
        this.totalAmount = 0;
        this.getUserInfoFromService();
        console.log('mostramos la respuesta: ', response);
        this.messageService.add({
            severity: 'success',
            summary: '',
            detail: 'Se realizo la peticion con exito'
          });
      },
      error => {
        this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error
          });
      })

  }

  private fillModel(): ElectronicPaymentModel {
    let model: ElectronicPaymentModel = new ElectronicPaymentModel();
    model.deviceSessionId = this.openpay.deviceSessionId;
    model.listOfWinners = this.itemsSelected;
    return model;
  }*/

  addReference(value) {
    //this.itemsSelected = [value.data];
    /*if (value.data.account !== 'OK') {
         this.itemsSelected = _.remove(this.itemsSelected, item => {
        console.log(item.wagerReferenceId, value.data.wagerReferenceId, item.wagerReferenceId == value.data.wagerReferenceId)
        return item.wagerReferenceId == value.data.wagerReferenceId
      });
    } else {*/
    _.remove(this.itemsSelected, item => item.id.wagerReferenceIdKey === value.data.id.wagerReferenceIdKey);
    this.itemsSelected = _.concat(this.itemsSelected, value.data);
    this.getTotales();
    //}

  }

  /*  cancelReference(value){
      _.remove(this.itemsSelected, item => {
          console.log(item.wagerReferenceId, value.data.wagerReferenceId, item.wagerReferenceId == value.data.wagerReferenceId)
          return item.wagerReferenceId == value.data.wagerReferenceId
        });
    }*/

  onRowSelect(event) {

    /*console.log(event);
    if (event.data.account !== 'OK') {
      //this.itemsSelected.splice(event.data, 1);
      let itemsTmp = this.itemsSelected;
      this.itemsSelected = [];
      _.remove(itemsTmp, item => {
        console.log(item.wagerReferenceId, event.data.wagerReferenceId, item.wagerReferenceId == event.data.wagerReferenceId)
        return item.wagerReferenceId == event.data.wagerReferenceId
      });


      this.itemsSelected = _.concat(this.itemsSelected, itemsTmp);
    }
    console.log(this.itemsSelected);*/
    this.getTotales();

  }

  onRowUnselect(event) {
    this.getTotales();
  }

  getTotales() {
    this.comisionesAmount = 0;
    this.totalAmount = 0;
    _.forEach(this.itemsSelected, item => {
      /*this.comisionesAmount += item.fee;
      this.totalAmount += item.total2Paid;*/
      this.totalAmount = parseFloat(this.totalAmount.toString()) + parseFloat(item.amountPrize)
    });
  }

  display: boolean = false;
  showDialog() {
    this.display = true;
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/payments/read-dataTable/read-dt.component.ts